import React from 'react'
import { useSelector } from 'react-redux'
import { LoadingBlocker } from '@/components/Loader'
import { Step1, Step2, Step3, Error } from './resultSms'
import { VERIFICATION_STEPS_NAME } from '@/entity/verification/constants'

const Step = ({ step, onSuccess }) => {
	let render = {
		[VERIFICATION_STEPS_NAME.step1]: <Step1 />,
		[VERIFICATION_STEPS_NAME.step2]: <Step2 />,
		[VERIFICATION_STEPS_NAME.step3]: <Step3 onSuccess={onSuccess} />,
		[VERIFICATION_STEPS_NAME.error]: <Error />,
	}

	return render[step] || false
}

export const VerificationSms = ({ onSuccess }) => {
	const { step_name, isLoading } = useSelector((state) => ({
		step_name: state.verification.step_name,
		isLoading: state.verification.isLoading,
	}))

	return (
		<>
			{isLoading ? <LoadingBlocker /> : null}

			<Step step={step_name} onSuccess={onSuccess} />
		</>
	)
}
